<template>
  <div class="cashier-wrap">
    <div class="cashier">
      <div class="my-card-title">收银台</div>
      <div class="cashier-content">
        <div class="product-info">
          <div class="product-name">商品信息：{{ form.subject }}</div>
          <div class="price">订单金额<i>{{ form.price }}</i>元</div>
        </div>

        <div class="pay-type-wrap">
          <div class="pay-type-title">
            <p>预存支付</p>
            <div class="tip">余额：{{ (form.balance) }}</div>
          </div>
          <div class="form-check under-line">
            <input class="form-check-input" type="radio" name="pay-type" id="pay-type0" v-model="form.payment_type"
              value="2">
            <label class="form-check-label custom-label" for="pay-type0">
              <img src="~@/assets/images/balance_pay.png" alt="">{{ order_type ? '团队预存余额' : '个人预存余额' }}<span class="tip"
                style="margin-left: 15px;">您还没有预存，预存可以一次开票、多次使用，省去每次开票的麻烦！<router-link
                  :to="{ path: '/recharge/user' }"><i>立即预存</i></router-link></span>
            </label>
          </div>
          <div class="pay-type-title">
            <p>其他方式</p>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="pay-type" id="pay-type1" v-model="form.payment_type"
              value="0">
            <label class="form-check-label custom-label" for="pay-type1">
              <img src="~@/assets/images/wx_pay.png" alt="">微信支付
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="pay-type" id="pay-type2" v-model="form.payment_type"
              value="1">
            <label class="form-check-label custom-label" for="pay-type2">
              <img src="~@/assets/images/ali_pay.png" alt="">支付宝支付
            </label>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="pay-type" id="pay-type3" v-model="form.payment_type"
              value="3">
            <label class="form-check-label custom-label" for="pay-type3">
              <img src="~@/assets/images/credit_pay.png" alt="">信用金支付
              <span v-if="auth_status" class="tip">（可用额度：￥{{ credit_deposit }}元）</span>
              <span v-if="!auth_status" class="tip" style="margin-left: 15px;">0元下单，先测试后付款， 快去<router-link
                  :to="{ path: '/user/profile' }"><i>实名认证</i></router-link> ，领取你的5000元信用额度</span>
            </label>
          </div>
          <div class="mgt10" v-if="form.payment_type == 2 || form.payment_type == 3">
            <div class="pay-type-title">
              <p>支付密码</p>
            </div>
            <div class="pay-password">
              <div class="password-inp">
                <el-input type="password" style="width:200px" v-model="form.pay_password" placeholder="请输入支付密码">
                </el-input>
                <i @click="resetPayPassword">忘记密码？</i>
              </div>
              <div class="tip">请输入6位数字支付密码</div>
            </div>
          </div>
          <div class="form-check">
            <input class="form-check-input" type="radio" name="pay-type" id="pay-type4" v-model="form.payment_type"
              value="4">
            <label class="form-check-label custom-label" for="pay-type4">
              <img src="~@/assets/images/offline.png" alt="">线下转账
            </label>
          </div>
          <template v-if="form.payment_type == 4">
            <div class="flex-row mgt10 mgb10">
              <label class="flex-xy-center mgr20 color333">付款凭证</label>
              <div>
                <div class="input-group">
                  <form-images v-model="form.voucher" :config="{}"></form-images>
                  <div class="tip mgt20 fs13">提示：请上传gif,jpg,png,jpeg,等格式图片，大小不超过4M</div>
                </div>
              </div>
            </div>

            <div class="">
              <div class="remittance-info">
                <label class="fwb fs14">账号信息</label>
                <div class="list">
                  <div>开户名称：</div>
                  <div>{{ config.account_name }}</div>
                  <div>开户银行：</div>
                  <div>{{ config.bank_name }}</div>
                  <div>专属汇款账号：</div>
                  <div>{{ config.account_no }}</div>
                </div>
              </div>
            </div>

          </template>

        </div>
      </div>
      <div class="flex-xy-center">
        <el-button class="pay-btn" @click="handleSubmit" :loading="loading">确认并支付</el-button>
      </div>
    </div>
    <!-- 付款二维码 -->
    <pay-qrcode :pay="pay" :visible.sync="showQrcodeForm" @success="handleSuccess" />
    <!-- 重置支付密码 -->
    <ResetPayPassword :visible.sync="showResetPayPasswordForm" />
  </div>
</template>

<script>
import { getConfig } from "@/api/common";
import { getPreview, doPay } from "@/api/pay";
import PayQrcode from '@/components/payQrcode';
import ResetPayPassword from '@/components/resetPayPassword';
import FormImages from '@/components/form/images' //多图上传
export default {
  name: "Cashier",
  components: {
    PayQrcode,
    ResetPayPassword,
    FormImages
  },
  props: {},
  data() {
    return {
      showQrcodeForm: false,
      showResetPayPasswordForm: false,
      loading: false,
      form: {
        type: 1,
        order_id: 0,
        password: '',
        payment_type: 0,
        price: null,
        integral: null,
        balance: 0,
        price: 0,
        subject: '',
        voucher: [],
      },
      pay: {},
      order_type: 0,
      auth_status: 0,
      credit_deposit: 0,
      config: {}
    }
  },
  filters: {

  },
  computed: {

  },
  created() {
    this.form.order_id = this.$route.query.order_id || 0
    this.form.type = this.$route.query.type || 0
    this.getConfig()
    this.getPreview()
  },
  mounted() {

  },
  methods: {
    getConfig() {
      getConfig({ group: 'account' }).then((res) => {
        this.config = res.data
      }).catch((err) => {
        console.log(err);
      })
    },
    getPreview() {
      getPreview(this.form).then(res => {
        this.form.price = res.data.price;
        this.form.balance = res.data.balance;
        this.form.subject = res.data.subject;
        this.order_type = res.data.order_type;
        this.auth_status = res.data.auth_status;
        this.credit_deposit = res.data.credit_deposit;
      }).catch((err) => {

      });
    },
    resetPayPassword() {
      this.showResetPayPasswordForm = true;
    },
    // 提交订单
    handleSubmit() {
      const _form = this.form;
      if (_form.payment_type == 4) {
        if (_form.voucher.length == 0) {
          this.$message.error('请上传付款凭证！');
          return false;
        }
        _form.voucher = _form.voucher.map(item => {
          return item.url
        })
      }
      this.loading = true
      doPay(_form)
        .then((res) => {
          this.loading = false;
          if (res.data.payment_type == 0 || res.data.payment_type == 1) {
            this.pay = res.data
            this.showQrcodeForm = true;
          } else {
            // 弹出操作提示
            this.$message({
              type: 'success',
              message: res.msg
            }), setTimeout(() => {
              this.$router.push({ path: '/user/index' })
            }, 1000);
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    //支付成功
    handleSuccess() {
      const type = this.form.type;
      if (type == 0) {
        this.$router.push({ path: '/user/order/list/project' })
      } else if (type == 1) {
        this.$router.push({ path: '/user/order/list/store' })
      } else {
        this.$router.push({ path: '/user/index' })
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.cashier-wrap {
  width: 100%;
  background: #F4F8F9;
  padding: 50px 0 239px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;

  .cashier {
    width: 940px;

    .cashier-content {
      width: 100%;
      padding: 31px 20px 57px 20px;
      box-sizing: border-box;
      background: #FFFFFF;

      .product-info {
        display: flex;
        align-items: center;
        justify-content: space-around;
        font-size: 14px;
        font-weight: 400;
        color: #222222;

        i {
          font-size: 24px;
          font-weight: bold;
          color: #FF6666;
        }
      }

      .pay-type-wrap {
        width: 100%;
        padding: 25px 42px 49px 42px;
        box-sizing: border-box;
        font-size: 14px;
        font-weight: 400;
        color: #333333;
        background: #F4F8F9;
        border-radius: 4px;
        margin-top: 30px;

        .pay-type-title {
          display: flex;
          align-items: center;
          column-gap: 35px;
          margin-bottom: 9px;
        }

        .tip {
          font-size: 14px;
          font-weight: 300;
          color: #A0A9AC;

          i {
            color: #00B4E8;
          }
        }

        .under-line {
          border-bottom: 1px solid #a7acb22c;
          margin-bottom: 15px;
        }

        .pay-password {
          .password-inp {
            display: flex;
            align-items: center;
            column-gap: 20px;
            margin-bottom: 10px;

            i {
              color: #00B4E8;
              cursor: pointer;
            }
          }
        }

        .form-check {
          display: grid;
          grid-template-columns: 18px auto;
          align-items: center;
          column-gap: 0;
          line-height: initial;
          padding: 9px 0;

          .custom-label {
            display: flex;
            align-items: center;
            font-size: 14px;
            font-weight: 300;
            color: #333333;

            &>img {
              width: 30px;
              max-height: 100%;
              margin-left: 20px;
              margin-right: 20px;
            }
          }

          .total-num {
            text-align: end;
            font-size: 14px;
            font-weight: 300;
            color: #222222;

            i {
              font-size: 14px;
              font-weight: bold;
              color: #FF6666;
            }
          }
        }

        .remittance-info {
          width: 100%;
          padding: 16px 0 23px 0;
          background: #e0e5e6;
          border-radius: 4px;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          flex-direction: column;
          font-size: 14px;
          font-weight: 400;
          color: #6F7F84;

          .list {
            display: grid;
            grid-template-columns: 98px auto;
            gap: 13px;
            margin-top: 15px;

            div:nth-child(odd) {
              text-align: right;
            }

            div:last-child {
              color: #00B4E8;
              font-weight: bold;
            }
          }
        }
      }
    }

    .pay-btn {
      padding: 10px 40px;
      box-sizing: border-box;
      background: #00B4E8;
      border-radius: 25px;
      font-size: 20px;
      font-weight: 400;
      color: #FFFFFF;
      width: fit-content;
      margin: 45px 0 0 auto;
      cursor: pointer;
    }
  }
}
</style>
